/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createDigitalWalletLink} from '../api'

export const useMutationCreateDigitalWalletLink = createReactQueryMutationHook('createDigitalWalletLink', createDigitalWalletLink)
